import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Sidebar } from "./style";
import { AddButton } from "../../../../components/addButton";

class ToolsSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasShadow: false
    };

    this.onScroll = this.onScroll.bind(this);
  }

  onScroll(event) {
    if (event.target.scrollTop >= 10) {
      this.setState({ hasShadow: true });
    } else {
      this.setState({ hasShadow: false });
    }
  }

  renderItem(item, path, key) {
    const { history } = this.props;
    const { link, title, icon, imgIcon, SvgIcon } = item;
    const _link = link && (typeof link == "function" ? link(history) : link);

    return (
      <NavLink
        key={key}
        to={_link || "#"}
        className={path === _link ? "list-item-active" : ""}
      >
        <li>
          {icon && <i className={"icon " + (icon || "mapsa-home")} />}
          {imgIcon && <img className="image-icon" src={imgIcon} alt="" />}
          {SvgIcon && <div className="svg-icon-wrapper"><SvgIcon /></div>}
          <span className="list-item-text">{title}</span>
        </li>
      </NavLink>
    );
  }

  render() {
    const {
      onAddClick,
      addButton,
      menu,
      SubComponent,
      history,
      menuBar
    } = this.props;
    const { pathname, search } = this.props.history.location;
    const { hasShadow } = this.state;
    const disable =
      addButton.disable &&
      (typeof addButton.disable == "function"
        ? addButton.disable(history)
        : addButton.disable);

    return (
      <Sidebar onScroll={this.onScroll} expand>
        <AddButton
          hasShadow={hasShadow}
          title={(addButton && addButton.title) || "افزودن"}
          onClick={() => onAddClick && !disable && onAddClick()}
          disable={disable}
          style={{ position: "sticky", top: 0 }}
          menuBar={menuBar}
          expand
        />

        <div className="sidebar-list">
          <ul>
            {menu &&
              menu.map((item, index) =>
                this.renderItem(item, pathname + search, index)
              )}
          </ul>
          {SubComponent}
        </div>
      </Sidebar>
    );
  }
}

export default withRouter(ToolsSidebar);
